import { ImageProps } from "@lib/image";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";

export class StrapiTeamMemberDTO {
  constructor() {}

  displayName: string;
  slug: string;
  qualification: string;
  role: string;
  bio: string;
  photo: StrapiMediaDTO;
  sortIndex: number;
  isHeadOfPractice: boolean;
}

export class TeamMemberDTO {
  constructor() {}

  extraData: any = {};
  displayName: string;
  slug: string;
  qualification: string;
  role: string;
  bio: MDXRemoteSerializeResult;
  /** first bio paragraph as plain text — what team CARDS show; the full bio
   *  belongs only to the member's own page */
  bioTeaser: string;
  /** alias of bioTeaser for the shared entity-SEO compiler (P8q) */
  teaser?: string;
  /** shared.seo override (P8q — was written by editors but never fetched) */
  seo?: { metaTitle?: string; metaDescription?: string; metaImage?: { url?: string };
    metaRobots?: string; canonicalURL?: string; structuredData?: object };
  photo: ImageProps;
  sortIndex: number;
  isHeadOfPractice: boolean;
}
